import { render, staticRenderFns } from "./ImageFull.vue?vue&type=template&id=094d205e"
import script from "./ImageFull.vue?vue&type=script&lang=js"
export * from "./ImageFull.vue?vue&type=script&lang=js"
import style0 from "./ImageFull.vue?vue&type=style&index=0&id=094d205e&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports